﻿import { RefObject, useEffect } from 'react';
import { Modal, Paper, useMediaQuery, useTheme } from '@mui/material';
import { DiiaQRCode, TimerRefHandle } from '../DiiaQRCode';
import { styles } from './styles';

interface DiiaVerificationProps {
  deepLink: string;
  timerRef: RefObject<TimerRefHandle | null>;
  qrCodeTimer: number;
  modalDiiaVerification: boolean;
  handleCloseModal: () => void;
}

export const DiiaVerification = ({
  deepLink,
  timerRef,
  modalDiiaVerification,
  handleCloseModal,
  qrCodeTimer,
}: DiiaVerificationProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (!modalDiiaVerification) {
      timerRef.current?.resetTimer();
      return;
    }

    const startTimerWhenMounted = () => {
      timerRef.current?.startTimer();
    };

    startTimerWhenMounted();
    const timeoutId = setTimeout(startTimerWhenMounted, 0);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [modalDiiaVerification, timerRef]);

  return (
    <Modal open={modalDiiaVerification} onClose={handleCloseModal} disableScrollLock={isMobile}>
      <Paper sx={styles.modalContainer(isMobile)}>
        <DiiaQRCode
          deepLink={deepLink}
          timerRef={timerRef}
          qrCodeTimer={qrCodeTimer}
          diiaTitle={'Поділитися документами в Дії'}
          instructionText={
            'Дотримуйтеся подальших інструкцій в застосунку Дія. Потрібно надати копії РНОКПП та наявного паспорта (ID-картки або закордонного)'
          }
        />
      </Paper>
    </Modal>
  );
};
